class Footer {
  constructor() {
    this.init();
  }

  initKlaviyoForm() {
    /* insert a new p tag as the last child within the '#rich-text-4339628' element */
    const p = document.createElement("div");
    p.classList.add("footer-newsletter__copy");
    p.innerHTML =
      "Join our newsletter for updates about new products, collections and special offers.";

    if (document.querySelector("#rich-text-4339628") != null)
      document.querySelector("#rich-text-4339628").appendChild(p);
  }

  init() {
    /* Interval and wait until '.klaviyo-form-PdELwX form' element exists */
    let count = 0;
    const interval = setInterval(() => {
      if (document.querySelector(".klaviyo-form-PdELwX form")) {
        clearInterval(interval);
        this.initKlaviyoForm();
      } else {
        count++;
        if (count > 100) {
          clearInterval(interval);
        }
      }
    }, 100);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Footer();
});
